import { Box } from '@material-ui/core'
import { CSSProperties } from '@material-ui/core/styles/withStyles'
import { PlainLoader } from 'components/core/loader'
import { PropsWithChildren } from 'react'
import { Waypoint } from 'react-waypoint'
import styled from 'styled-components'
import { PageInner } from './PageInner'
import { usePaginatedContent } from './hooks/usePaginatedContent'

const StyledBottomIndicator = styled(Box)`
  && {
    display: flex;
    justify-content: center;
    width: 100%;
    color: ${props => props.theme.colors.accent1};
  }
`

export const BOTTOM_PAGE_TRIGGER = '__bottom_page_trigger'

export interface IPaginatedContentProps {
  endpoint: string
  renderFunction: (listItem: any, index: number, array: Array<any>) => any
  height: string

  style?: CSSProperties
  width?: string
  searchParams?: {
    [key: string]: string | number
    page?: number
    pageSize?: number
    dir?: 'desc' | 'asc'
    sort?: string
  }
  endpointSpecificSearchParams?: {
    [key: string]: any
  }
  nothingFoundText?: string
  noMoreItemsText?: string
  showNothingFoundText?: boolean
  showNoMoreItemsText?: boolean
}

export const PaginatedContent = ({
  endpoint,
  renderFunction,
  searchParams,
  height,
  style,
  width,
  endpointSpecificSearchParams,
  nothingFoundText,
  noMoreItemsText,
  showNothingFoundText,
  showNoMoreItemsText
}: PropsWithChildren<IPaginatedContentProps>) => {
  const { items, getItems, isLoading, isLastPage } = usePaginatedContent(
    endpoint,
    searchParams,
    endpointSpecificSearchParams
  )

  return (
    <PageInner width={width} height={height} style={style} bottomPadding='100px'>
      <Box width="100%">{items?.map?.(renderFunction)}</Box>
      <Box width="100%">
        {isLoading && (
          <StyledBottomIndicator width="100%" display="flex" justifyContent="center">
            <PlainLoader />
          </StyledBottomIndicator>
        )}
        {(typeof showNothingFoundText === 'undefined' || showNothingFoundText) && !isLoading && !items?.length && (
          <StyledBottomIndicator width="100%" display="flex" justifyContent="center">
            {nothingFoundText || "Nothing found"}
          </StyledBottomIndicator>
        )}
        {(typeof showNoMoreItemsText === 'undefined' || showNoMoreItemsText) && !isLoading && items?.length && isLastPage && (
          <StyledBottomIndicator width="100%" display="flex" justifyContent="center">
            {noMoreItemsText || "Nothing more has been found"}
          </StyledBottomIndicator>
        )}
        <Waypoint
          onEnter={() => {
            getItems()
          }}
        />
      </Box>
    </PageInner>
  )
}
